import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicTable } from '../../../../theme/Component/BasicTable';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../core/services/dataBean/EntityCatalog';
import { PrintJson } from '../../../../theme/Component/PrintJson';

interface Props {
    idAccount: number;
    label?: string;
    onChange?: any;
}

export const EditorVacationsPeriodForEmployeeContract = ({ label, onChange, idAccount }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_EmployeeContract);
    const [renderValue, setRenderValue] = useState<string>("");
    const [idContrac, setContrac] = useState<number>(null);
    const [listaVac, setListaVac] = useState<any>([]);


    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const getLista = () => {
        instance.getActiveEmployeeContract(idAccount).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        );
    }

    const head = [
        { title: 'Año de Vacaciones', property: 'VacYear', visible: true },
        { title: 'Periodo', property: 'VacPeriod', visible: true },
    ]

    const selectItem = () => {
        if (bean.VacYear && bean.VacPeriod) {
            setModal({ ...modal, "view": false });
            onChange?.(bean);
            setRenderValue(`${bean.VacYear} - ${bean.VacPeriod}`)
        } else {
            toast.error("Periodo de Vacaciones Invalido")
        }
    };

    useEffect(() => {
        getLista()
    }, [idAccount]);

    useEffect(() => {
        if (idContrac) {
            instance.getVacationsPeriodForEmployeeContract(idContrac).then(
                (resp) => {
                    setListaVac(resp)
                }
            ).catch(
                err => { toast.error(err) }
            )
        }
    }, [idContrac])

    return (
        <>
            <label>{label ? label : 'Periodo de Vacaciones'}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Contrato Laboral</label>
                        <select className='form-select' value={idContrac} onChange={(e) => {
                            const resp = e.target.value ? Number(e.target.value) : null;
                            setContrac(resp)
                        }} >
                            <option value=""></option>
                            {lista.map((item) => {
                                return (
                                    <option value={item.DataBeanProperties.IDContract}>{item.DataBeanProperties.EntailmentName} - {item.DataBeanProperties.Period}</option>
                                )
                            })}
                        </select>
                    </div>

                </div>
                <BasicTable body={listaVac} head={head} rowSet={setBean} />
            </Modal>
        </>
    );
}
